function DTWishlist() {    
  const LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
  const LOCAL_STORAGE_DELIMITER = ',';
  const BUTTON_ACTIVE_CLASS = 'added';
  const GRID_LOADED_CLASS = 'loaded';
  const LOADING_STATUS = 'adding';

  const selectors = {
    button: '[button-wishlist]',
    button_main: '[button-wishlist-main]',
    grid: '[grid-wishlist]',
    productCard: '.wishlist__grid-item',
  };

  // --- Initialize Wishlist Buttons ---
  const initButtons = () => {
    document.querySelectorAll(selectors.button + ',' + selectors.button_main).forEach(button => {
      const productHandle = button.dataset.productHandle;
      if (!productHandle) return;

      // Update state
      if (wishlistContains(productHandle)) {
        button.classList.add(BUTTON_ACTIVE_CLASS);
      } else {
        button.classList.remove(BUTTON_ACTIVE_CLASS);
      }
    });
  };

  // --- Wishlist Click Handler (Event Delegation) ---
  document.addEventListener('click', (e) => {
    const button = e.target.closest(selectors.button + ',' + selectors.button_main);
    if (!button) return;

    const productHandle = button.dataset.productHandle;
    if (!productHandle) return;

    button.classList.add(LOADING_STATUS);
    updateWishlist(productHandle);

    setTimeout(() => {
      button.classList.remove(LOADING_STATUS);
      button.classList.toggle(BUTTON_ACTIVE_CLASS);
    }, 500);
  });

  // --- Fetch Wishlist Product HTML ---
  const fetchProductCardHTML = async (handle) => {
    const url = `/products/${handle}?view=card`;
    try {
      const res = await fetch(url);
      const text = await res.text();
      const parser = new DOMParser();
      const htmlDocument = parser.parseFromString(text, 'text/html');
      const productCard = htmlDocument.querySelector(selectors.productCard);
      return productCard ? productCard.outerHTML : '';
    } catch (err) {
      console.error(`[Shopify Wishlist] Error loading product: ${handle}`, err);
      return '';
    }
  };

  // --- Load Wishlist Grid ---
  const setupGrid = async (grid) => {
    const wishlist = getWishlist();
    if (!wishlist.length) {
      grid.innerHTML = wdtTheme.strings.wislistEmpty;
      grid.classList.add('empty-list');
      return;
    }

    const requests = wishlist.map(fetchProductCardHTML);
    const responses = await Promise.all(requests);
    grid.innerHTML = responses.join('');
    grid.classList.add(GRID_LOADED_CLASS);
    initButtons();
  };

  // --- Init Grid ---
  const initGrid = () => {
    const grid = document.querySelector(selectors.grid);
    if (grid) setupGrid(grid);
    wishListCount();
  };

  // --- Get Wishlist from LocalStorage ---
  const getWishlist = () => {
    const wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY);
    return wishlist ? wishlist.split(LOCAL_STORAGE_DELIMITER) : [];
  };

  // --- Save Wishlist to LocalStorage ---
  const setWishlist = (array) => {
    if (array.length) {
      localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, array.join(LOCAL_STORAGE_DELIMITER));
    } else {
      localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);
    }

    document.dispatchEvent(new CustomEvent('shopify-wishlist:updated', { detail: { wishlist: array } }));
  };

  // --- Add/Remove Item from Wishlist ---
  const updateWishlist = (handle) => {
    const wishlist = getWishlist();
    const index = wishlist.indexOf(handle);

    if (index === -1) wishlist.push(handle);
    else wishlist.splice(index, 1);

    setWishlist(wishlist);
    wishListCount();
  };

  // --- Check if Handle Exists ---
  const wishlistContains = (handle) => getWishlist().includes(handle);

  // --- Update Wishlist Count ---
  const wishListCount = () => {
    const count = getWishlist().length;
    const bubble = document.querySelector('.wishlist-count-bubble span');
    if (bubble) bubble.textContent = count;

    document.querySelectorAll(".dtxc-wishlist-count").forEach(el => {
      el.style.display = count > 0 ? "block" : "none";
    });

    // Update footer heart
    const wishlistBubble = document.getElementById('dtxc-wishlistBubble');
    const footerHeart = document.getElementById('footerHeart');
    if (wishlistBubble && footerHeart) {
      footerHeart.innerHTML = '';
      footerHeart.appendChild(wishlistBubble.cloneNode(true));
    }
  };

  // --- Listen for Wishlist Updates ---
  document.addEventListener('shopify-wishlist:updated', initGrid);

  // --- Initialize ---
  initButtons();
  initGrid();
}


document.addEventListener('DOMContentLoaded', () => {
  DTWishlist();
});


document.addEventListener('shopify:section:load', () => {
  DTWishlist();
});
